module.exports = __webpack_public_path__ + "media/social-instagram-e5178ff0.svg";